import React, { Component } from "react";
import CustomDropdown from "./ChartsOptionsSidebar/CustomDropdown";

import moment from "moment";

class IntervalSelector extends Component {
    state = {};

    render() {
        let week_disabled = false,
            hour_disabled = false,
            day_disabled = false,
            month_disabled = false,
            year_disabled = false;
        if (this.props.appliedFilter && (this.props.appliedFilter.duration == "24HRS" || this.props.appliedFilter.duration == 1)) {
            // day_disabled = true;
            // week_disabled = true;
            // month_disabled = true;
            // year_disabled = true;
        } else if (this.props.appliedFilter && this.props.appliedFilter.duration == "7") {
            // week_disabled = true;
            // month_disabled = true;
            // year_disabled = true;
        } else if (this.props.appliedFilter && this.props.appliedFilter.duration == "30") {
            hour_disabled = true;
            // month_disabled = true;
            // year_disabled = true;
        } else if (this.props.appliedFilter && this.props.appliedFilter.duration == "lastmonth") {
            hour_disabled = true;
        } else if (this.props.appliedFilter && this.props.appliedFilter.duration == "lastquarter") {
            hour_disabled = true;
        } else if (this.props.appliedFilter && this.props.appliedFilter.duration == "last2quarter") {
            hour_disabled = true;
        } else if (this.props.appliedFilter && ["all", "30", "lastmonth", "lastquarter", "last2quarter"].includes(this.props.appliedFilter.creationDuration)) {
            if (this.props.appliedFilter.creationDuration === "all") {
                day_disabled = true;
            }
            hour_disabled = true;
        } else if (this.props.appliedFilter && this.props.appliedFilter.duration == "custom") {
            let diff = moment(this.props.appliedFilter.end_date).diff(this.props.appliedFilter.start_date, "days", true);
            if (!this.props.appliedFilter.end_date)
                diff = moment(this.props.appliedFilter.creationEndDateTime).diff(this.props.appliedFilter.creationStartDateTime, "days", true);
            if (diff <= 1) {
                // day_disabled = true;
                // week_disabled = true;
                // month_disabled = true;
                // year_disabled = true;
            } else if (diff > 1 && diff <= 29) {
                // week_disabled = true;
                // month_disabled = true;
                // year_disabled = true;
            } else if (diff > 29 && diff < 90) {
                hour_disabled = true;
                // month_disabled = true;
                // year_disabled = true;
            } else if (diff >= 90 && diff < 366) {
                hour_disabled = true;
                // year_disabled = true;
            } else if (diff >= 366) {
                hour_disabled = true;
                day_disabled = true;
            }
        }
        this.props.disableComparisonInterval &&
            this.props.disableComparisonInterval.map((val) => {
                //  console.log("hello", val);
                if (val == "hour") hour_disabled = true;
                if (val == "day") day_disabled = true;
            });

        const aggsIntervalOptions = [
            { label: "Hourly", value: "hour", disabled: hour_disabled },
            { label: "Daily", value: "day", disabled: day_disabled },
            { label: "Weekly", value: "week", disabled: week_disabled },
            { label: "Monthly", value: "month", disabled: month_disabled },
            { label: "Yearly", value: "year", disabled: year_disabled },
        ];

        const aggsIntervalOptionsRemoveHour = [
            // { label: "Hourly", value: "hour", disabled: hour_disabled },
            { label: "Daily", value: "day", disabled: day_disabled },
            { label: "Weekly", value: "week", disabled: week_disabled },
            { label: "Monthly", value: "month", disabled: month_disabled },
            { label: "Yearly", value: "year", disabled: year_disabled },
        ];

        return (
            <CustomDropdown
                className="interval-selector"
                name="Select Interval"
                options={this.props.removeInterval ? aggsIntervalOptionsRemoveHour : aggsIntervalOptions}
                value={this.props.aggs_val}
                onChange={this.props.handleIntervalChange}
                // removeInterval={this.props.removeInterval}
            />
        );
    }
}

export default IntervalSelector;
